export default __webpack_public_path__ + "static/media/2134.11319afe.png";